export enum CalendarEventType {
  Order = "Order",
  WorkOrder = "WorkOrder",
  Inspection = "Inspection",
}
